// src/price/index.ts
var formatPrice = (price, maximumFractionDigits = 2) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits
  }).format(+price);
};
var addVatToPrice = (price, vat = 15) => {
  const vatPercentage = vat / 100;
  const vatValue = 1 + vatPercentage;
  const validPrice = Number(price) || 0;
  return validPrice * vatValue;
};
var calculareDiscountPercentage = (originalPrice, price) => {
  return Math.round(Math.abs((originalPrice - price) / originalPrice) * 100);
};

export {
  formatPrice,
  addVatToPrice,
  calculareDiscountPercentage
};
//# sourceMappingURL=chunk-H7BCPEP5.mjs.map